<template>
    <div class="relative isolate overflow-hidden bg-gray-950 py-16 sm:py-24 lg:py-32">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2">
                <div class="max-w-xl lg:max-w-lg">
                    <h2 class="text-4xl font-semibold tracking-tight text-white">{{ t('headings.subscribe-to-newsletter') }}</h2>
                    <p class="mt-4 text-lg text-gray-300">{{ t('headings.newsletter-description') }}</p>
                    <div class="mt-6 flex max-w-md gap-x-4">
                        <label for="email-address" class="sr-only">{{ t('headings.email') }}</label>
                        <input id="email-address" name="email" type="email" autocomplete="email" required=""
                            class="min-w-0 flex-auto rounded-md bg-white/5 px-3.5 py-2 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-emerald-500 sm:text-sm/6"
                            :placeholder="t('headings.enter-email')" />
                        <button type="submit"
                            class="flex-none rounded-md bg-emerald-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-emerald-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-500">{{ t('headings.subscribe') }}</button>
                    </div>
                </div>
                <dl class="grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:pt-2">
                    <div class="flex flex-col items-start">
                        <div class="rounded-md bg-white/5 p-2 ring-1 ring-white/10">
                            <CalendarDaysIcon class="size-6 text-white" aria-hidden="true" />
                        </div>
                        <dt class="mt-4 text-base font-semibold text-white">{{ t('headings.weekly-articles') }}</dt>
                        <dd class="mt-2 text-base/7 text-gray-400">{{ t('headings.weekly-articles-description') }}</dd>
                    </div>
                    <div class="flex flex-col items-start">
                        <div class="rounded-md bg-white/5 p-2 ring-1 ring-white/10">
                            <HandRaisedIcon class="size-6 text-white" aria-hidden="true" />
                        </div>
                        <dt class="mt-4 text-base font-semibold text-white">{{ t('headings.no-spam') }}</dt>
                        <dd class="mt-2 text-base/7 text-gray-400">{{ t('headings.no-spam-description') }}</dd>
                    </div>
                </dl>
            </div>
        </div>
        <!--<div class="absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6" aria-hidden="true">
            <div class="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ffbcd8] to-[#a0ffe0] opacity-30"
                style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />
        </div>-->
    </div>
</template>

<script setup>
import { CalendarDaysIcon, HandRaisedIcon } from '@heroicons/vue/24/outline'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
